import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKr = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	id: "flag-icons-kr",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fillOpacity: .7,
			d: "M-95.8-.4h682.7v512H-95.8z"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipPath: "url(#a)",
		transform: "translate(89.8 .4) scale(.9375)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "#fff",
				d: "M-95.8-.4H587v512H-95.8Z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(-56.3 361.6 -101.3) scale(10.66667)",
				children: [
					/* @__PURE__ */ _jsxs("g", {
						id: "c",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "b",
							d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
						}), /* @__PURE__ */ _jsx("use", {
							xlinkHref: "#b",
							width: "100%",
							height: "100%",
							y: 44
						})]
					}),
					/* @__PURE__ */ _jsx("path", {
						stroke: "#fff",
						d: "M0 17v10"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#cd2e3a",
						d: "M0-12a12 12 0 0 1 0 24Z"
					}),
					/* @__PURE__ */ _jsx("path", {
						fill: "#0047a0",
						d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
					}),
					/* @__PURE__ */ _jsx("circle", {
						cy: -6,
						r: 6,
						fill: "#cd2e3a"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "rotate(-123.7 191.2 62.2) scale(10.66667)",
				children: [/* @__PURE__ */ _jsx("use", {
					xlinkHref: "#c",
					width: "100%",
					height: "100%"
				}), /* @__PURE__ */ _jsx("path", {
					stroke: "#fff",
					d: "M0-23.5v3M0 17v3.5m0 3v3"
				})]
			})
		]
	})]
});
export default SvgKr;
